import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { Loader } from "./Loader";
import { primaryColors } from "../theme/colors";
export default () => markdown `
## Loader
  ${(<ReactSpecimen>
      <Loader />
    </ReactSpecimen>)}

## Loader with label
  ${(<ReactSpecimen>
      <Loader label="Loading data"/>
    </ReactSpecimen>)}


## Custom size and color

  ${(<ReactSpecimen>
      <Loader size={20} color={primaryColors.zuerichBlue} label="Loading data"/>
    </ReactSpecimen>)}

  ## Vertically centered

  In flex containers, loaders will be centered automatically.

  ${(<ReactSpecimen>
      <div style={{ height: 400, display: "flex" }}>
        <Loader label="Loading data"/>
      </div>
    </ReactSpecimen>)}
`;



// WEBPACK FOOTER //
// ./src/components/Loader.docs.tsx